import { DocumentEntity } from 'serviceWorker/repository/document/entity';

export function createUrlFromEventDocument(
  document: DocumentEntity
): string {
  return `/event/${document.eventId}`;
}

export function createUrlFromIncomingEmailMessageDocument(
  document: DocumentEntity
): string {
  return `/incomingEmailMessage/${document.incomingEmailMessageId}`;
}

export function createUrlFromIssueDocument(
  document: DocumentEntity
): string {
  const url = `/issue/${document.issueId}`;
  if (document.eventId) {
    return url + createUrlFromEventDocument(document);
  }
  if (document.incomingEmailMessageId) {
    return url + createUrlFromIncomingEmailMessageDocument(document);
  }

  return url;
}
